import * as types from './types';

export const initialState = {
  uid: '',
  email: '',
  isLoading: true
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_AUTH:
      return {
        ...state,
        uid: action.payload.uid || '',
        email: action.payload.email || '',
      };
    case types.SET_AUTH_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case types.CLEAR_AUTH:
      return {
        ...initialState,
        isLoading: false  // After clearing, auth state is determined (user is logged out)
      };
    default:
      return state;
  }
};

export default authReducer;
